import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { currency } from '@utils';
import { Button, LoadingIndicator } from '@components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReservaMatematicaService } from '@services';
import { useSelector } from 'react-redux';

export const ReservaMatematicaPage = () => {
  const navigate = useNavigate();
  const { matricula, plano } = useSelector((state) => state.user.data);
  const [loading, setLoading] = useState(false);
  const [dadosReserva, setDadosReserva] = useState({ ExibirTermo: true });

  const handleClick = () => {
    const service = new ReservaMatematicaService();
    setLoading(true);

    service
      .setReservaPlanoA(matricula)
      .then((post) => {
        if (post === 'true') {
          service
            .getReservaPlanoA(matricula, plano)
            .then((res) => {
              setDadosReserva(res);
            })
            .catch(() => {
              toast.error('Erro ao obter dados');
            })
            .finally(() => {
              setLoading(false);
            });
        }
      })
      .catch(() => {
        toast.error('Erro ao obter dados');
      });
  };

  return !loading ? (
    <>
      <Helmet>
        <title>Forluz - Reserva Matemática</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Reserva Matemática</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          {!dadosReserva.ExibirTermo ? (
            <>
              <h2>
                <strong>Dados da Reserva</strong>
              </h2>
              <div className="row mb-4 mt-4">
                <div className="col-12 col-md-12 col-lg-4 mt-2">
                  <p className="text-orange fw-bold ts-20">Valor da reserva</p>
                  <p className="text-muted fw-bold ts-18 mt-2">
                    {currency(dadosReserva.reserva)}
                  </p>
                </div>
                <div className="col-12 col-md-12 col-lg-4 mt-2">
                  <p className="text-orange fw-bold ts-20">
                    Data de referência
                  </p>
                  <p className="text-muted fw-bold ts-18 mt-2">
                    {dadosReserva.referencia}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <>
              <h2>
                <strong>Termo de Aceite</strong>
              </h2>
              <p className="mt-32">
                Como condição para obter a informação do valor da minha Reserva
                Matemática Individual e Hipotética, posicionada em dezembro do
                último exercício, declaro ter lido e compreendido o presente
                termo e com ele concordado, em todo o seu conteúdo. <br />
                <br /> O meu benefício é estruturado na modalidade de Benefício
                Definido - BD, que tem como base o princípio do
                MUTUALISMO/COLETIVIDADE. Em atenção a esse princípio, não
                existe, tecnicamente, valor individual de Reserva Matemática em
                planos estruturados nessa modalidade. Por esse motivo não
                existem contas individuais mantidas em favor de cada um dos
                Participantes separadamente. <br />
                <br />A Reserva Matemática representa a obrigação previdenciária
                presente de um plano de benefícios frente aos seus participantes
                e assistidos e é apurada para fins de estudos atuariais e de
                solvência do plano, sendo calculadas com base em premissas
                previamente definidas (longevidade, taxa de juros, alterações de
                grupo familiar inscrito para fins de Renda Continuada por Morte
                - RCM, aniversário do participante e/ou grupo familiar, entre
                outras). Tal Reserva representa o total do compromisso futuro
                projetado pela Forluz, em valor presente atuarial, para honrar o
                pagamento de benefícios.
                <br />
                <br />
                Tenho o conhecimento de que as premissas demográficas,
                econômicas e financeiras vigentes estão disponibilizadas no
                Parecer Atuarial do Relatório Anual de Informações do último
                exercício, acessível no Portal da Forluz. Possuo ciência também
                de que as formulações necessárias para a apuração do meu
                benefício estão contidas na Nota Técnica Atuarial - NTA vigente,
                disponível no Portal da Forluz.
                <br />
                <br />
                Faz-se necessário frisar que o valor da reserva matemática não
                possui uma evolução linear crescente ao longo do tempo. Ao
                contrário, sua tendência é de diminuir com o aumento da idade do
                participante, além de poder ser impactada, positiva ou
                negativamente, pela alteração de qualquer uma das já mencionadas
                premissas. <br />
                <br />
                Entendo que, apesar de possível matematicamente a
                individualização de provisões matemáticas, o que deve ocorrer em
                casos de estratégias previdenciais, como a migração para um
                plano de contribuição definida, tal fato só ocorre pela quebra
                do mutualismo, de forma que, na continuidade do regime mútuo,{' '}
                <b>
                  não se deve associar a provisão matemática como direito do
                  participante
                </b>
                , visto que seu direito é o do recebimento da renda vitalícia,
                enquanto observadas as regras regulamentares.
                <br />
                <br />
                Diante do exposto, declaro ter ciência de que a informação do
                valor da minha Reserva Matemática Individual e Hipotética tem
                finalidade meramente informativa e, por essa razão, não implica
                quaisquer direitos sobre ela ou alterações no meu benefício.
              </p>
              <div>
                <Button className="mt-32" onClick={handleClick}>
                  Li e aceito os termos
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
